export default "__VITE_ASSET__d2709a81__"